/**
 * Short label for a course file (storage key or URL path).
 * @param {{ nombre?: string } | null | undefined} archivo
 * @param {string} [emptyFallback="Archivo"]
 * @returns {string}
 */
export function displayArchivoNombre(archivo, emptyFallback = "Archivo") {
  if (!archivo || typeof archivo !== "object") {
    return emptyFallback;
  }
  const raw = typeof archivo.nombre === "string" ? archivo.nombre.trim() : "";
  if (!raw) {
    return emptyFallback;
  }
  const slash = raw.lastIndexOf("/");
  const basename = slash >= 0 && slash < raw.length - 1 ? raw.slice(slash + 1) : raw;
  // Uploaded course files use `${timestamp}_${uuid}_${originalName}` as object keys.
  return basename.replace(/^\d{13}_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i, "");
}
